export const mapArrayToIdName = <T extends { id?: string | null; name?: string | null }>(
  arr: T[]
): Record<string, string> => {
  return arr.reduce((acc, item) => {
    if (item.id && item.name) {
      acc[item.id] = item.name === 'OpenAudience' ? 'OpenXSelect' : item.name;
    }

    return acc;
  }, {});
};
